import { useQuery } from "react-query";

import { pendoService } from "services";

type UsePendoGetUserProfileQuery = {
	isEnabled: boolean;
	onSuccess?: (data) => void;
};

const usePendoGetUserProfileQuery = ({
	isEnabled = false,
	onSuccess,
}: UsePendoGetUserProfileQuery) =>
	useQuery(["pendoGetUserProfile"], () => pendoService.getUserProfile(), {
		onSuccess: (data: { [key: string]: any }) => {
			onSuccess?.(data);
		},
		enabled: !!isEnabled,
		cacheTime: 0,
		retry: 3,
	});

export default usePendoGetUserProfileQuery;
